import { createStore } from "vuex";
import axios from "axios";
import user from "./user";

let store = createStore({
    modules: {user},
    state(){
        return {
            patientJSON: null,
            buttonJSON: null,
            images: null,
            availablePatients: [],
            completePatients: [],
            uiLanguageJSON: null,
            saveData: null,
            aboutText: "Error: Loading Failed",
            tipsText: "Error: Loading Failed",
            severeShockText: "Error: Loading Failed",
            sirsSepsisText: "Error: Loading Failed",
            newsScoreText: "Error: Loading Failed",
            sofaScoreText: "Error: Loading Failed"
        }
    },
    getters: {
        getAllPatients(state){ return state.patientJSON; },

        // return a single patient, and remove it from the list of available patients
        getNewPatient(state){
            let availableIndex = Math.floor(Math.random() * state.availablePatients.length);
            let patient = state.patientJSON[state.availablePatients[availableIndex]];
            state.availablePatients.splice(availableIndex, 1)
            return patient;
        },

        patientsRemaining(state){ return state.availablePatients.length; },
        getButtons(state){ return state.buttonJSON; },
        getActionById(state){
            return function(id){
                console.log(id);
                for (const val of Object.values(state.buttonJSON)){
                    for (const item of val){
                        if(item.lab === id || item.treatment === id){
                            console.log(item);
                            return item;
                        }
                    }
                }
            }
        },
        getImage(state){
            return function(image){
                return state.images[image];
            }
        },
        getUIText(state){
            return function(key, replace){
                if(state.uiLanguageJSON === null) return ''
                let text = state.uiLanguageJSON[key]
                if(replace){
                    text = text.replace("[X]", replace);
                }
                return text;
            }
        },
        getSaveData(state){return state.saveData},
        getPatientByName(state){
            return function(name){
                for(let i=0; i < state.patientJSON.length; i++){
                    if(state.patientJSON[i].name === name){
                        return state.patientJSON[i];
                    }
                }
            }
        },
        aboutText(state){
            return state.aboutText;
        },
        tipsText(state){
            return state.tipsText;
        },
        severeShockText(state){
            return state.severeShockText;
        },
        sirsSepsisText(state){
            return state.sirsSepsisText;
        },
        newsScoreText(state){
            return state.newsScoreText;
        },
        sofaScoreText(state){
            return state.sofaScoreText;
        },
        numCompletePatients(state){
            return state.completePatients.length;
        },
        getCompletePatients(state){
            return state.completePatients;
        }
    },
    mutations: {
        setPatients(state, patients){ state.patientJSON = patients; },
        setButtons(state, buttons){ state.buttonJSON = buttons; },
        setImages(state, images){ state.images = images; },
        setAvailablePatients(state){
            // create new array [0, ... , N-1] where N is the number of loaded patients
            state.availablePatients = Array.from(Array(state.patientJSON.length).keys());
        },
        loadAvailablePatients(state, patient_array){
            state.availablePatients = patient_array;
        },
        setUILanguage(state, json){ state.uiLanguageJSON = json; },
        setSaveData(state, payload) {
            payload.timestamp = Date.now();
            payload.availablePatients = state.availablePatients;
            payload.completePatients = state.completePatients;
            state.saveData = payload;
            // localStorage.setItem('saveData', JSON.stringify(payload));
        },
        setSaveDataDirectly(state, payload){
            state.saveData = payload;
            // localStorage.setItem('saveData', JSON.stringify(payload));
        },
        addCompletePatient(state, payload){
            state.completePatients.push(payload);
        },
        loadCompletePatients(state, patient_array){
            state.completePatients = patient_array;
        },
        setAboutText(state, payload){
            state.aboutText = payload;
        },
        setTipsText(state, payload){
            state.tipsText = payload;
        },
        setSevereShockText(state, payload){
            state.severeShockText = payload;
        },
        setSirsSepsisText(state, payload){
            state.sirsSepsisText = payload;
        },
        setNewsScoreText(state, payload){
            state.newsScoreText = payload;
        },
        setSofaScoreText(state, payload){
            state.sofaScoreText = payload;
        }
    },
    actions: {
        // Start a new game
        initialize(context, region){
            return axios.all([
                context.dispatch('loadPatients', {region: region, url: process.env.VUE_APP_PATIENTS}),
                context.dispatch('loadButtons'),
                context.dispatch('loadImages')
            ]);
        },
        initTutorial(context){
            return axios.all([
                context.dispatch('loadPatients', { region: "Any", url: process.env.VUE_APP_TUTORIAL_PATIENTS }),
                context.dispatch('loadButtons', process.env.VUE_APP_TUTORIAL_BUTTONS),
                context.dispatch('loadImages')
            ]);
        },
        // Load a fresh set of patients from json
        loadPatients(context, {region, url}){
            return new Promise((resolve, reject) => {
                axios.get('./' + url)
                    .then(returnData => {
                        console.log(returnData.data);
                        returnData.data.forEach(patient=>{
                            // Remove treatment data for other resistance regions
                            for(let i=0; i<patient.treatments.length; i++){
                                if(Object.hasOwn(patient.treatments[i], "antibioticResistance")
                                    && patient.treatments[i].antibioticResistance !== "Any"
                                    && patient.treatments[i].antibioticResistance !== ""
                                    && patient.treatments[i].antibioticResistance !== region)
                                {
                                    patient.treatments.splice(i, 1);
                                    i--; // we removed an item from the array, so i should be the same next loop to not skip a row
                                }
                            }
                            // And again for Combos
                            for(let i=0; i< patient.combos.length; i++){
                                if(Object.hasOwn(patient.combos[i], "antibioticResistance")
                                    && patient.combos[i].antibioticResistance !== "Any"
                                    && patient.combos[i].antibioticResistance !== ""
                                    && patient.combos[i].antibioticResistance !== region)
                                {
                                    patient.combos.splice(i, 1);
                                    i--; // we removed an item from the array, so i should be the same next loop to not skip a row
                                }
                            }
                        });
                        context.commit("setPatients", returnData.data);
                        resolve();
                    })
                    .catch(error=>{ reject(error) });
            })
        },
        // Load the button json
        async loadButtons(context, url = process.env.VUE_APP_BUTTONS){
            return new Promise((resolve, reject)=>{
                console.log("buttons", url)
                axios.get('./' + url)
                    .then(data=>{
                        context.commit("setButtons", data.data);
                        resolve();
                    })
                    .catch(error=>{ reject(error); })
            })
        },
        loadImages(context){
            // Load images into Webpack context
            let path = require.context('@/assets/images/', true);
            let images = {};
            let keys = path.keys()
            return new Promise((resolve, reject)=>{
                if(!keys){
                    reject("No image keys");
                }
                // Map images into object, keyed by filename
                keys.map((v, i)=>{
                    images[v] = keys.map(path)[i];
                });
                context.commit("setImages", images);
                resolve();
            })
        },
        loadUILanguage(context){
            return new Promise((resolve, reject) => {
                console.log(process.env.VUE_APP_UI)
                axios.get('./' + process.env.VUE_APP_UI)
                    .then(returnData => {
                        console.log(returnData.data);
                        context.commit("setUILanguage", returnData.data);
                        resolve();
                    })
                    .catch(err=>{reject(err)})
            });
        },
        loadAbout(context){
            return new Promise((resolve, reject) => {
                let about, tips, sirs_sepsis, severe_shock, news_score, sofa_score;
                const about_p = axios.get("./" + process.env.VUE_APP_ABOUT).then(returnData=>{
                    about = returnData.data;
                    context.commit("setAboutText", returnData.data);
                }).catch(err=>{reject(err)})
                const tips_p = axios.get("./" + process.env.VUE_APP_TIPS).then(returnData=>{
                    tips = returnData.data
                    context.commit("setTipsText", returnData.data);
                }).catch(err=>{reject(err)})
                const sirs_sepsis_p = axios.get("./" + process.env.VUE_APP_SIRS_SEPSIS).then(returnData=>{
                    sirs_sepsis = returnData.data
                    context.commit("setSirsSepsisText", returnData.data);
                }).catch(err=>{reject(err)})
                const severe_shock_p = axios.get("./" + process.env.VUE_APP_SEVERE_SHOCK).then(returnData=>{
                    severe_shock = returnData.data
                    context.commit("setSevereShockText", returnData.data);
                }).catch(err=>{reject(err)})
                const news_score_p = axios.get("./" + process.env.VUE_APP_NEWS_SCORE).then(returnData=>{
                    news_score = returnData.data
                    context.commit("setNewsScoreText", returnData.data);
                }).catch(err=>{reject(err)})
                const sofa_score_p = axios.get("./" + process.env.VUE_APP_SOFA_SCORE).then(returnData=>{
                    sofa_score = returnData.data
                    context.commit("setSofaScoreText", returnData.data);
                }).catch(err=>{reject(err)})
                axios.all([about_p, tips_p, sirs_sepsis_p, severe_shock_p, news_score_p, sofa_score_p]).then(()=>{
                    resolve({about: about, tips: tips, sirs_sepsis: sirs_sepsis, severe_shock: severe_shock, news_score: news_score, sofa_score: sofa_score});
                })
            })
        },
        loadGameFromSave(context){
            //let saveDataJSON = JSON.parse(context.getters.getSaveData);
            console.log(context.getters.getSaveData);
            context.commit("loadAvailablePatients", context.getters.getSaveData.availablePatients);
            context.commit("loadCompletePatients", context.getters.getSaveData.completePatients);
        }
    }
});

export default store;
